module.exports = __webpack_public_path__ + "img/parking.2457806f.svg";